import { Select } from '../../../components/ui';
import type { FieldControlProps } from '../../../components/ui';
import { useT } from '../../../i18n';
import { cn } from '../../../lib/cn';
import { O_MAU } from '../constants';
import { ACCENT_NAMES, ICON_NAMES, TRENDS } from '../types';
import type { AccentName, IconName, Trend } from '../types';

/**
 * Ô chọn cho ENUM ĐÓNG của hợp đồng di động. `Select` chứ không `Input`: giá trị ngoài danh sách làm app
 * di động vỡ **cả trang**, không phải bỏ qua một trường. Danh sách đóng ở đây là lớp chặn đầu; backend trả
 * 400 là lớp thứ hai; CHECK của Postgres là lớp thứ ba.
 *
 * Mọi ô nhận prop a11y của `<Field>` để nhãn gắn đúng ô.
 */
type ChonProps<T> = Partial<FieldControlProps> & { value: T; onChange: (v: T) => void; disabled?: boolean };

/**
 * Biểu tượng: hiện tên enum kèm nghĩa, không vẽ hình. Cổng không biết app vẽ glyph nào (icon biên dịch sẵn
 * trong bundle của app) — vẽ một hình gần đúng là hứa một thứ không kiểm được. Tên enum là giá trị thật
 * đi xuống API, đối chiếu được khi đọc log.
 */
export function ChonIcon({ value, onChange, ...con }: ChonProps<IconName>) {
  const { t } = useT();
  return (
    <Select<IconName>
      {...con}
      className="w-full"
      showSearch={{ optionFilterProp: 'label' }}
      value={value}
      onChange={onChange}
      options={ICON_NAMES.map((n) => ({ value: n, label: `${n} — ${t(`baoCaoDoanhNghiep.bieuTuong.${n}`)}` }))}
    />
  );
}

/** Màu nhấn là tên token màu: ô chọn vẽ đúng màu sẽ gửi đi, kể cả ở ô đã chọn. */
export function ChonMauNhan({ value, onChange, ...con }: ChonProps<AccentName>) {
  const { t } = useT();
  return (
    <Select<AccentName>
      {...con}
      className="w-full"
      value={value}
      onChange={onChange}
      options={ACCENT_NAMES.map((n) => ({
        value: n,
        label: (
          <span className="inline-flex items-center gap-2">
            <span className={cn('size-3 shrink-0 rounded-full', O_MAU[n])} aria-hidden />
            <span>{t(`baoCaoDoanhNghiep.mauNhan.${n}`)}</span>
            <span className="font-mono text-2xs text-content-muted">{n}</span>
          </span>
        ),
      }))}
    />
  );
}

export function ChonXuHuong({ value, onChange, ...con }: ChonProps<Trend>) {
  const { t } = useT();
  return (
    <Select<Trend>
      {...con}
      className="w-full"
      value={value}
      onChange={onChange}
      options={TRENDS.map((n) => ({ value: n, label: t(`baoCaoDoanhNghiep.xuHuongGiaTri.${n}`) }))}
    />
  );
}
